import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  CardText, CardHeader, 
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  TabContent, 
  TabPane,
  Row, 
  Col,
  Input,
  Table,
  Alert
} from "reactstrap"
import Select from "react-select"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import { connect } from "react-redux"

const NewAssettype = props => {

  const history = useHistory();

  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  // const [maintype, setMaintype] = useState('');
  const [status, setStatus] = React.useState(1);

  const [errors, setErrors] = React.useState([]);
  
  const [loading, setLoading] = React.useState(false);

  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_ASSETTYPE+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setName(response.data.name);
        setCode(response.data.code);
        // setMaintype(response.data.main_type);
        setStatus(response.data.status);
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch asset type data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };


  const handleSubmit = () => {
    if(name == '') {
      cogoToast.error('asset type name is required');
      return;
    }

    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      name: name,
      code: code,
      // main_type: maintype,
      status: status,
      property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
      // repeat: repeat ? 1 : 0,
    };

    console.log('data', data);
    // return;

    setLoading(true);
    setErrors([]);
    // axios.post('/api/beacon/create', {
    post(url.POST_NEW_ASSETTYPE, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/assettypes/index');
        cogoToast.success('Asset type '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };

  React.useEffect(()=>{
    if(props.match.params.id && props.match.params.id !== 'new') {
      fetchData(props.match.params.id);
    }
  }, []);

  // console.log('params:', props.match.params.id);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add New' : 'Edit') : 'Add New'} Asset type | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} Asset type</h3>
            <Link className="btn btn-secondary" to="/assettypes/index">Back</Link>
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Name</label>
                    <div className="col-sm-9">
                      <input autoFocus type="text" className="form-control" id="name"  value={name} onChange={e=>{ setName(e.target.value); }} />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Code</label>
                    <div className="col-sm-9">
                      <input type="text" className="form-control" id="name"  value={code} onChange={e=>{ setCode(e.target.value); }} />
                    </div>
                  </div>
                  {/* <div className="mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Main type</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={maintype}
                        onChange={(e)=>{ setMaintype(e.target.value); }}
                        >
                        <option value="NONMETER">Non-meter</option>
                        <option value="METER">Meter</option>
                      </select>
                    </div>
                  </div> */}
                  <div className="mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={status}
                        onChange={(e)=>{ setStatus(e.target.value); }}
                        >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>


     </Container>

    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary me-2" onClick={()=>{ handleSubmit(); }}>Submit</button>
        <Link className="btn btn-light" to="/assettypes/index">Cancel</Link>
      </div>
    </div>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
    filterProperty
  } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(NewAssettype)